import { render, staticRenderFns } from "./edit_role.vue?vue&type=template&id=41d46815&scoped=true"
import script from "./edit_role.vue?vue&type=script&lang=js"
export * from "./edit_role.vue?vue&type=script&lang=js"
import style0 from "./edit_role.vue?vue&type=style&index=0&id=41d46815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d46815",
  null
  
)

export default component.exports